import { z } from "zod/v4";

export const GetConfigRequestPathParamSchema = z.object({
  id: z.string(),
});

export type GetConfigRequestPathParamType = z.infer<
  typeof GetConfigRequestPathParamSchema
>;
